import type { IAnalyticMetricShowing } from '../../analytics/types/metric';

import { useShopMetaCreateOrUpdateMutation } from '~/api/graphql/mutations/shopMetaCreateOrUpdate.generated';
import { useShopMetaByKeyQuery } from '~/api/graphql/queries/shopMetaByKey.generated';
import { CAMPAIGN_ANALYTIC_MAPPING_SHOWING } from '~/modules/campaign-analytics';
import { useAnalyticStore } from '~/modules/analytics';
import { deepCopy } from '~/utils';

const GEMX_ANALYTICS_SWITCH_METRIC_KEY = 'gemx:analytics:switch-metric';

export const useHandleSwitchMetric = () => {
  const metricShowing = useAnalyticStore((state) => state.metricShowing);
  const setMetricShowing = useAnalyticStore((state) => state.setMetricShowing);
  const shopMetaCreateOrUpdateMutation = useShopMetaCreateOrUpdateMutation();

  useShopMetaByKeyQuery(
    {
      key: GEMX_ANALYTICS_SWITCH_METRIC_KEY,
    },
    {
      enabled: !metricShowing,
      onSuccess: (data) => {
        const shopMetaValue = data?.shopMetaByKey?.value;
        if (shopMetaValue) {
          const metricShowing = JSON.parse(shopMetaValue);
          setMetricShowing(metricShowing);
        } else {
          setMetricShowing(CAMPAIGN_ANALYTIC_MAPPING_SHOWING);
        }
      },
    },
  );

  const handleSetMetricShowing = async (value: IAnalyticMetricShowing[]) => {
    setMetricShowing(value);
    await shopMetaCreateOrUpdateMutation.mutateAsync({
      input: {
        key: GEMX_ANALYTICS_SWITCH_METRIC_KEY,
        value: JSON.stringify(value),
      },
    });
  };

  const handleMetricShowingChange = (value: IAnalyticMetricShowing) => {
    const currentData = deepCopy(metricShowing);
    if (!currentData) return;

    const index = currentData.findIndex((item) => item.position === value.position);
    if (index === -1) return;

    currentData[index] = value;
    handleSetMetricShowing(currentData);
  };

  return {
    metricShowing,
    handleSetMetricShowing,
    handleMetricShowingChange,
  };
};
